import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { toast } from 'react-hot-toast'
import { MVPButton } from '../../Views/Buttons/MVPButton'
import { useNavigate } from '../navigation'
import { useActiveGameId } from '../../state/hooks/ActiveGameHooks'
import PaymentModal from '../../Views/modals/PaymentModal/PaymentModal'
import '../../index.scss'
import './MainPage.scss'
import { LobbyChatView } from '../Lobby/Chat/LobbyChatView'

const GameCard = ({ onClick }: { onClick: () => void }) => {
	return (
		<div className='game-card' onClick={onClick}>
			<div className='game-card-overview' />
			<h2 className='game-card-label'>Live Dealt Poker</h2>
		</div>
	)
}

export default () =>
{
	const goToGame = useNavigate('game')
	const goToLobby = useNavigate('lobby')
	const activeGameId = useActiveGameId()
	const [searchParams] = useSearchParams()
	const [paymentProcessed, setPaymentProcessed] = useState<boolean | undefined>(undefined)
	
	const paymentProcessedQuery = searchParams.get('payment_processed')
	if (paymentProcessedQuery !== null && paymentProcessed === undefined) {
		setPaymentProcessed(paymentProcessedQuery === 'true')
	}
	useEffect(() => {
		if (paymentProcessed !== undefined) {
			PaymentModal.Show(paymentProcessed)
		}
	}, [paymentProcessed])

	useEffect(() => {
		if (activeGameId){
			const goToActiveRoom = async () => {
				goToGame({ replace: true })
			}
			goToActiveRoom()
		}
	}, [activeGameId])

	return (
		<div id='main-page-content'>
			<div id='center-col'>
				<h1 className='page-prompt'>Choose your preferred game</h1>
				<GameCard onClick={() => goToLobby()} />
				<MVPButton id='aditional-games-button'>Additional Games coming soon</MVPButton>
			</div>
			{/* <LobbyChatView /> */}
			<h1 id="topinfo">PLAYMONEY GAMES</h1>
		</div>
	)
}
